import axios, { AxiosInstance, AxiosRequestConfig } from "axios";

import store from "@/store";
import EventBus from "./EventBus";

export class DataProvider {
  private apiUrl = process.env.VUE_APP_API_BASE_URL;
  private http: AxiosInstance;

  constructor() {
    this.http = axios.create({
      baseURL: this.apiUrl,
      headers: {
        "Content-Type": "application/json"
      }
    });

    this.http.interceptors.response.use(
      response => {
        return response;
      },
      error => {
        if (error.response.status === 401) {
          const requestUrl = error.response.config.url;

          if (!requestUrl.includes("logout")) {
            store.dispatch("session/userLogout", null, { root: true });
          }
        }

        if (error.response.status === 403) {
          EventBus.$emit("show-permission-popup");
        }

        return Promise.reject(error);
      }
    );
  }

  public get<T>(url: string, params: AxiosRequestConfig = {}) {
    return this.http.get<T>(`${this.apiUrl}${url}`, params);
  }

  public post<T>(url: string, payload?: any) {
    return this.http.post<T>(`${this.apiUrl}${url}`, payload);
  }

  public put<T>(url: string, payload: any) {
    return this.http.put<T>(`${this.apiUrl}${url}`, payload);
  }

  public delete<T>(url: string, params: AxiosRequestConfig = {}) {
    return this.http.delete<T>(`${this.apiUrl}${url}`, params);
  }

  public patch<T>(url: string, payload: any) {
    return this.http.patch<T>(`${this.apiUrl}${url}`, payload);
  }

  public setDefaultHeader(name: string, value: string) {
    this.http.defaults.headers.common[name] = value;
  }
}

export default new DataProvider();
